import { type GasPayload } from '@atlaskit/analytics-gas-types';

export const onSearchDialogErrorShown = ({
	attributes,
	nonPrivacySafeAttributes,
}: {
	attributes: Record<string, any>;
	nonPrivacySafeAttributes: Record<string, any>;
}): GasPayload => ({
	eventType: 'ui',
	action: 'shown',
	actionSubject: `searchDialogError`,
	attributes,
	nonPrivacySafeAttributes,
});
